import { MatInputModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PrintComponent } from './print/print/print.component';
import { LoaderGifComponent } from './loader-gif/loader-gif.component';
import { LoaderScanningComponent } from './loader-scanning/loader-scanning.component';
import { DynamicMenuComponent } from './dynamic-menu/dynamic-menu.component';
import { BreadCrumbComponent } from './bread-crumb/bread-crumb.component';
import { AutoLogoutComponent } from './auto-logout/auto-logout.component';
import { NgModule } from '@angular/core';
import {
  Md2TooltipModule,
  Md2AutocompleteModule,
  Md2MenuModule,
  Md2DataTableModule,
  MdNativeDateModule,
  Md2SelectModule,
  // Md2SelectHeader,
  Md2OptionModule
} from 'md2';
import { SharedModule } from '../shared/shared.module';
import { ApiProgressingComponent } from './api-progressing/api-progressing.component';
import { CKEditorModule } from 'ng2-ckeditor';
import { PoChartComponent } from './po-chart/po-chart.component';
// import { DynamicProjectChartComponent } from './dynamic-project-chart/dynamic-project-chart.component';
// import { DynamicChartComponent } from './dynamic-chart/dynamic-chart.component';

@NgModule({
  imports: [
    CommonModule,
    Md2TooltipModule,
    Md2AutocompleteModule,
    Md2SelectModule,
    // Md2SelectHeader,
    Md2OptionModule,
    Md2DataTableModule,
    MdNativeDateModule,
    FormsModule,
    MatInputModule,
    Md2MenuModule,
    SharedModule,
    CKEditorModule
  ],
  exports: [
    AutoLogoutComponent,
    BreadCrumbComponent,
    DynamicMenuComponent,
    LoaderGifComponent,
    LoaderScanningComponent,
    PrintComponent,
    ApiProgressingComponent,

  ],
  declarations: [
    AutoLogoutComponent,
    BreadCrumbComponent,
    DynamicMenuComponent,
    PrintComponent,
    LoaderGifComponent,
    LoaderScanningComponent,
    ApiProgressingComponent,
  ],
  providers: []
})
export class CommonFunctioModule { }



// WEBPACK FOOTER //
// /codebuild/output/src1307711746/src/src/app/common/commonFunction.module.ts